/**
 * List of all of the Redux actions in the app.
 * Technically, the `= 'SomeStringFoo'` part is unnecessary, but if you leave it off, you're left looking at integers
 * in the dev tools.
 * E.g. `Action dispatched: {type: 14, customerId: 75849375934}` -- not so helpful... but it is smaller for prod builds.
 */
export enum ActionType {
  // Misc
  // -------------------------------------------------------------------------------------------------------------------
  UpdateStateAction                             = 'UpdateStateAction',
  SetPortalTypeAction                           = 'SetPortalTypeAction',
  ShowTimeoutModalAction                        = 'ShowTimeoutModalAction',
  ShowTimedOutAction                            = 'ShowTimedOutAction',
  SetTimedOutHandleAction                       = 'SetTimedOutHandleAction',

  ClearLoadingStateAction                       = 'ClearLoadingStateAction',

  // Localization
  // -------------------------------------------------------------------------------------------------------------------
  PortalLanguagesRequest                        = 'PortalLanguagesRequest',
  PortalLanguagesResponse                       = 'PortalLanguagesResponse',
  PortalLanguagesError                          = 'PortalLanguagesError',

  SetLocaleAction                               = 'SetLocaleAction',
  LoadTranslationsRequest                       = 'LoadTranslationsRequest',
  LoadTranslationsResponse                      = 'LoadTranslationsResponse',
  LoadTranslationsError                         = 'LoadTranslationsError',

  ProjectLanguagesRequest                       = 'ProjectLanguagesRequest',
  ProjectLanguagesResponse                      = 'ProjectLanguagesResponse',
  ProjectLanguagesError                         = 'ProjectLanguagesError',

  ProjectTranslationsRequest                    = 'ProjectTranslationsRequest',
  ProjectTranslationsResponse                   = 'ProjectTranslationsResponse',
  ProjectTranslationsError                      = 'ProjectTranslationsError',

  AllLanguagesRequest                        = 'AllLanguagesRequest',
  AllLanguagesResponse                       = 'AllLanguagesResponse',
  AllLanguagesError                          = 'AllLanguagesError',

  // Feature Flags and Configuration
  // -------------------------------------------------------------------------------------------------------------------
  LoadFeatureFlagsRequest                       = 'LoadFeatureFlagsRequest',
  LoadFeatureFlagsResponse                      = 'LoadFeatureFlagsResponse',
  LoadFeatureFlagsError                         = 'LoadFeatureFlagsError',

  LoadConfigRequest                             = 'LoadConfigRequest',
  LoadConfigResponse                            = 'LoadConfigResponse',
  LoadConfigError                               = 'LoadConfigError',

  ShowLoginAnnouncementRequest                  = 'ShowLoginAnnouncementRequest',
  ShowLoginAnnouncementResponse                 = 'ShowLoginAnnouncementResponse',
  ShowLoginAnnouncementError                    = 'ShowLoginAnnouncementError',

  // Login/Authentication
  // -------------------------------------------------------------------------------------------------------------------
  LoginRequest                                  = 'LoginRequest',
  LoginResponse                                 = 'LoginResponse',
  LoginError                                    = 'LoginError',
  LogOut                                        = 'LogOut',

  LoginTalentSmartRequest                       = 'LoginTalentSmartRequest',
  LoginTalentSmartResponse                      = 'LoginTalentSmartResponse',
  LoginTalentSmartError                         = 'LoginTalentSmartError',

  LoginBXRequest                                = 'LoginBXRequest',
  LoginBXResponse                               = 'LoginBXResponse',
  LoginBXError                                  = 'LoginBXError',

  SecurityQuestionKeysRequest                   = 'SecurityQuestionKeysRequest',
  SecurityQuestionKeysResponse                  = 'SecurityQuestionKeysResponse',
  SecurityQuestionKeysError                     = 'SecurityQuestionKeysError',

  SecurityQuestionRequest                       = 'SecurityQuestionRequest',
  SecurityQuestionResponse                      = 'SecurityQuestionResponse',
  SecurityQuestionError                         = 'SecurityQuestionError',

  SendPortalPasswordResetEmailRequest           = 'SendPortalPasswordResetEmailRequest',
  SendPortalPasswordResetEmailResponse          = 'SendPortalPasswordResetEmailResponse',
  SendPortalPasswordResetEmailError             = 'SendPortalPasswordResetEmailError',

  SendRaterApprovalPasswordResetEmailRequest    = 'SendRaterApprovalPasswordResetEmailRequest',
  SendRaterApprovalPasswordResetEmailResponse   = 'SendRaterApprovalPasswordResetEmailResponse',
  SendRaterApprovalPasswordResetEmailError      = 'SendRaterApprovalPasswordResetEmailError',

  SendReportRecipientPasswordResetEmailRequest  = 'SendReportRecipientPasswordResetEmailRequest',
  SendReportRecipientPasswordResetEmailResponse = 'SendReportRecipientPasswordResetEmailResponse',
  SendReportRecipientPasswordResetEmailError    = 'SendReportRecipientPasswordResetEmailError',

  NewPasswordRequest                            = 'NewPasswordRequest',
  NewPasswordResponse                           = 'NewPasswordResponse',
  NewPasswordError                              = 'NewPasswordError',

  PasswordRequirementMessageRequest             = 'PasswordRequirementMessageRequest',
  PasswordRequirementMessageResponse            = 'PasswordRequirementMessageResponse',
  PasswordRequirementMessageError               = 'PasswordRequirementMessageError',

  CreateSecurityChallengeRequest                = 'CreateSecurityChallengeRequest',
  CreateSecurityChallengeResponse               = 'CreateSecurityChallengeResponse',
  CreateSecurityChallengeError                  = 'CreateSecurityChallengeError',

  YmcaLoginRequest                              = 'YmcaLoginRequest',
  YmcaLoginResponse                             = 'YmcaLoginResponse',
  YmcaLoginError                                = 'YmcaLoginError',
  YmcaSsoRequest                                = 'YmcaSsoRequest',
  YmcaSsoResponse                               = 'YmcaSsoResponse',
  YmcaSsoError                                  = 'YmcaSsoError',

  IsSsoRequest                                  = 'IsSsoRequest',
  IsSsoResponse                                 = 'IsSsoResponse',
  IsSsoError                                    = 'IsSsoError',
  SamlAssertionRequest                          = 'SamlAssertionRequest',
  SamlAssertionResponse                         = 'SamlAssertionResponse',
  SamlAssertionError                            = 'SamlAssertionError',

  // Project
  // -------------------------------------------------------------------------------------------------------------------
  OpenMenu                                      = 'OpenMenu',

  LoadProjectIdRequest                          = 'LoadProjectIdRequest',
  LoadProjectIdResponse                         = 'LoadProjectIdResponse',
  LoadProjectIdError                            = 'LoadProjectIdError',

  LoadProjectsRequest                           = 'LoadProjectsRequest',
  LoadProjectsResponse                          = 'LoadProjectsResponse',
  LoadProjectsError                             = 'LoadProjectsError',

  LoadProjectSummaryRequest                     = 'LoadProjectSummaryRequest',
  LoadProjectSummaryResponse                    = 'LoadProjectSummaryResponse',
  LoadProjectSummaryError                       = 'LoadProjectSummaryError',

  LoadCurrentStatusRequest                      = 'LoadCurrentStatusRequest',
  LoadCurrentStatusResponse                     = 'LoadCurrentStatusResponse',
  LoadCurrentStatusError                        = 'LoadCurrentStatusError',

  LoadParticipantRequirementsRequest            = 'LoadParticipantRequirementsRequest',
  LoadParticipantRequirementsResponse           = 'LoadParticipantRequirementsResponse',
  LoadParticipantRequirementsError              = 'LoadParticipantRequirementsError',

  LoadProjectResourcesRequest                   = 'LoadProjectResourcesRequest',
  LoadProjectResourcesResponse                  = 'LoadProjectResourcesResponse',
  LoadProjectResourcesError                     = 'LoadProjectResourcesError',

  UpdateConfidentialityRequest                  = 'UpdateConfidentialityRequest',
  UpdateConfidentialityResponse                 = 'UpdateConfidentialityResponse',
  UpdateConfidentialityError                    = 'UpdateConfidentialityError',

  LoadDevResourcesRequest                       = 'LoadDevResourcesRequest',
  LoadDevResourcesResponse                      = 'LoadDevResourcesResponse',
  LoadDevResourcesError                         = 'LoadDevResourcesError',

  GetProjectCSContactRequest                    = 'GetProjectCSContactRequest',
  GetProjectCSContactResponse                   = 'GetProjectCSContactResponse',
  GetProjectCSContactError                      = 'GetProjectCSContactError',

  GetEBookUrlRequest                            = 'GetEBookUrlRequest',
  GetEBookUrlResponse                           = 'GetEBookUrlResponse',
  GetEBookUrlError                              = 'GetEBookUrlError',

  GetECourseUrlRequest                          = 'GetECourseUrlRequest',
  GetECourseUrlResponse                         = 'GetECourseUrlResponse',
  GetECourseUrlError                            = 'GetECourseUrlError',

  GetECourseworkUrlRequest                      = 'GetECourseworkUrlRequest',
  GetECourseworkUrlResponse                     = 'GetECourseworkUrlResponse',
  GetECourseworkUrlError                        = 'GetECourseworkUrlError',

  GetECoursePopupRequest                        = 'GetECoursePopupRequest',
  GetECoursePopupResponse                       = 'GetECoursePopupResponse',
  GetECoursePopupError                          = 'GetECoursePopupError',  

  GetECourseworkPopupRequest                    = 'GetECourseworkPopupRequest',
  GetECourseworkPopupResponse                   = 'GetECourseworkPopupResponse',
  GetECourseworkPopupError                      = 'GetECourseworkPopupError',  

  ReassessmentRequest                           = 'ReassessmentRequest',
  ReassessmentResponse                          = 'ReassessmentResponse',
  ReassessmentError                             = 'ReassessmentError',

  // Rater
  // -------------------------------------------------------------------------------------------------------------------
  AddRaterByEmailRequest                        = 'AddRaterByEmailRequest',
  AddRaterByEmailResponse                       = 'AddRaterByEmailResponse',
  AddRaterByEmailError                          = 'AddRaterByEmailError',

  AddRaterByIdRequest                           = 'AddRaterByIdRequest',
  AddRaterByIdResponse                          = 'AddRaterByIdResponse',
  AddRaterByIdError                             = 'AddRaterByIdError',

  ParticipantRatersRequest                      = 'ParticipantRatersRequest',
  ParticipantRatersResponse                     = 'ParticipantRatersResponse',
  ParticipantRatersError                        = 'ParticipantRatersError',

  PreviousRatersRequest                         = 'PreviousRatersRequest',
  PreviousRatersResponse                        = 'PreviousRatersResponse',
  PreviousRatersError                           = 'PreviousRatersError',

  UndeliveredEmailsRequest                      = 'UndeliveredEmailsRequest',
  UndeliveredEmailsResponse                     = 'UndeliveredEmailsResponse',
  UndeliveredEmailsError                        = 'UndeliveredEmailsError',

  DirectoryRatersRequest                        = 'DirectoryRatersRequest',
  DirectoryRatersResponse                       = 'DirectoryRatersResponse',
  DirectoryRatersError                          = 'DirectoryRatersError',

  UpdateInviteDataRequest                       = 'UpdateInviteDataRequest',
  UpdateInviteDataResponse                      = 'UpdateInviteDataResponse',
  UpdateInviteDataError                         = 'UpdateInviteDataError',

  InviteEmailPreviewRequest                     = 'InviteEmailPreviewRequest',
  InviteEmailPreviewResponse                    = 'InviteEmailPreviewResponse',
  InviteEmailPreviewError                       = 'InviteEmailPreviewError',

  ApproverEmailPreviewRequest                   = 'ApproverEmailPreviewRequest',
  ApproverEmailPreviewResponse                  = 'ApproverEmailPreviewResponse',
  ApproverEmailPreviewError                     = 'ApproverEmailPreviewError',

  SendInvitationsRequest                        = 'SendInvitationsRequest',
  SendInvitationsResponse                       = 'SendInvitationsResponse',
  SendInvitationsError                          = 'SendInvitationsError',

  SendRemindersRequest                          = 'SendRemindersRequest',
  SendRemindersResponse                         = 'SendRemindersResponse',
  SendRemindersError                            = 'SendRemindersError',

  RaterLevelsRequest                            = 'RaterLevelsRequest',
  RaterLevelsResponse                           = 'RaterLevelsResponse',
  RaterLevelsError                              = 'RaterLevelsError',

  DeleteRaterRequest                            = 'DeleteRaterRequest',
  DeleteRaterResponse                           = 'DeleteRaterResponse',
  DeleteRaterError                              = 'DeleteRaterError',

  SaveEditedRater                               = 'SaveEditedRater',

  UpdateRaterRequest                            = 'UpdateRaterRequest',
  UpdateRaterResponse                           = 'UpdateRaterResponse',
  UpdateRaterError                              = 'UpdateRaterError',

  SetApproverRequest                            = 'SetApproverRequest',
  SetApproverResponse                           = 'SetApproverResponse',
  SetApproverError                              = 'SetApproverError',

  SendForApprovalRequest                        = 'SendForApprovalRequest',
  SendForApprovalResponse                       = 'SendForApprovalResponse',
  SendForApprovalError                          = 'SendForApprovalError',

  // Rater Approval
  // -------------------------------------------------------------------------------------------------------------------
  RaterApprovalParticipantsRequest              = 'RaterApprovalParticipantsRequest',
  RaterApprovalParticipantsResponse             = 'RaterApprovalParticipantsResponse',
  RaterApprovalParticipantsError                = 'RaterApprovalParticipantsError',

  RaterApprovalRatersRequest                    = 'RaterApprovalRatersRequest',
  RaterApprovalRatersResponse                   = 'RaterApprovalRatersResponse',
  RaterApprovalRatersError                      = 'RaterApprovalRatersError',

  SendRaterApprovalRequest                      = 'SendRaterApprovalRequest',
  SendRaterApprovalResponse                     = 'SendRaterApprovalResponse',
  SendRaterApprovalError                        = 'SendRaterApprovalError',

  UpdateApprovalStatusRequest                   = 'UpdateApprovalStatusRequest',
  UpdateApprovalStatusResponse                  = 'UpdateApprovalStatusResponse',
  UpdateApprovalStatusError                     = 'UpdateApprovalStatusError',

  UpdateApprovedForAllRequest                   = 'UpdateApprovedForAllRequest',
  UpdateApprovedForAllResponse                  = 'UpdateApprovedForAllResponse',
  UpdateApprovedForAllError                     = 'UpdateApprovedForAllError',

  ApproveRaterRequest                           = 'ApproveRaterRequest',
  ApproveRaterResponse                          = 'ApproveRaterResponse',
  ApproveRaterError                             = 'ApproveRaterError',

  DeclineRaterRequest                           = 'DeclineRaterRequest',
  DeclineRaterResponse                          = 'DeclineRaterResponse',
  DeclineRaterError                             = 'DeclineRaterError',

  RaterApprovalEmailPreviewRequest              = 'RaterApprovalEmailPreviewRequest',
  RaterApprovalEmailPreviewResponse             = 'RaterApprovalEmailPreviewResponse',
  RaterApprovalEmailPreviewError                = 'RaterApprovalEmailPreviewError',

  AddRaterByEmailAsApproverRequest              = 'AddRaterByEmailAsApproverRequest',
  AddRaterByEmailAsApproverResponse             = 'AddRaterByEmailAsApproverResponse',
  AddRaterByEmailAsApproverError                = 'AddRaterByEmailAsApproverError',

  // Create Survey
  // -------------------------------------------------------------------------------------------------------------------
  GetSelectedQuestionsRequest                   = 'GetSelectedQuestionsRequest',
  GetSelectedQuestionsResponse                  = 'GetSelectedQuestionsResponse',
  GetSelectedQuestionsError                     = 'GetSelectedQuestionsError',

  AddQuestionRequest                            = 'AddQuestionRequest',
  AddQuestionResponse                           = 'AddQuestionResponse',
  AddQuestionError                              = 'AddQuestionError',

  AddQuestionsForCompetencyRequest              = 'AddQuestionsForCompetencyRequest',
  AddQuestionsForCompetencyResponse             = 'AddQuestionsForCompetencyResponse',
  AddQuestionsForCompetencyError                = 'AddQuestionsForCompetencyError',

  DeleteQuestionRequest                         = 'DeleteQuestionRequest',
  DeleteQuestionResponse                        = 'DeleteQuestionResponse',
  DeleteQuestionError                           = 'DeleteQuestionError',

  DeleteQuestionsForCompetencyRequest           = 'DeleteQuestionsForCompetencyRequest',
  DeleteQuestionsForCompetencyResponse          = 'DeleteQuestionsForCompetencyResponse',
  DeleteQuestionsForCompetencyError             = 'DeleteQuestionsForCompetencyError',

  GetCompetenciesAndQuestionsRequest            = 'GetCompetenciesAndQuestionsRequest',
  GetCompetenciesAndQuestionsResponse           = 'GetCompetenciesAndQuestionsResponse',
  GetCompetenciesAndQuestionsError              = 'GetCompetenciesAndQuestionsError',

  ApplyPendingChangesRequest                    = 'ApplyPendingChangesRequest',
  ApplyPendingChangesResponse                   = 'ApplyPendingChangesResponse',
  ApplyPendingChangesError                      = 'ApplyPendingChangesError',

  UnsetCreatedSurveyRequest                     = 'UnsetCreatedSurveyRequest',
  UnsetCreatedSurveyResponse                    = 'UnsetCreatedSurveyResponse',
  UnsetCreatedSurveyError                       = 'UnsetCreatedSurveyError',

  // Dev Plan
  // -------------------------------------------------------------------------------------------------------------------
  GetDevPlanItemsRequest                        = 'GetDevPlanItemsRequest',
  GetDevPlanItemsResponse                       = 'GetDevPlanItemsResponse',
  GetDevPlanItemsError                          = 'GetDevPlanItemsError',

  GetDevPlanActionsRequest                      = 'GetDevPlanActionsRequest',
  GetDevPlanActionsResponse                     = 'GetDevPlanActionsResponse',
  GetDevPlanActionsError                        = 'GetDevPlanActionsError',

  GetDevPlanFieldsAndAnswersRequest             = 'GetDevPlanFieldsAndAnswersRequest',
  GetDevPlanFieldsAndAnswersResponse            = 'GetDevPlanFieldsAndAnswersResponse',
  GetDevPlanFieldsAndAnswersError               = 'GetDevPlanFieldsAndAnswersError',

  AddDevPlanItemRequest                         = 'AddDevPlanItemRequest',
  AddDevPlanItemResponse                        = 'AddDevPlanItemResponse',
  AddDevPlanItemError                           = 'AddDevPlanItemError',

  AddDevPlanActionRequest                       = 'AddDevPlanActionRequest',
  AddDevPlanActionResponse                      = 'AddDevPlanActionResponse',
  AddDevPlanActionError                         = 'AddDevPlanActionError',

  DeleteDevPlanItemRequest                      = 'DeleteDevPlanItemRequest',
  DeleteDevPlanItemResponse                     = 'DeleteDevPlanItemResponse',
  DeleteDevPlanItemError                        = 'DeleteDevPlanItemError',

  DeleteDevPlanActionRequest                    = 'DeleteDevPlanActionRequest',
  DeleteDevPlanActionResponse                   = 'DeleteDevPlanActionResponse',
  DeleteDevPlanActionError                      = 'DeleteDevPlanActionError',

  UpdateDevPlanItemDescriptionRequest           = 'UpdateDevPlanItemDescriptionRequest',
  UpdateDevPlanItemDescriptionResponse          = 'UpdateDevPlanItemDescriptionResponse',
  UpdateDevPlanItemDescriptionError             = 'UpdateDevPlanItemDescriptionError',

  UpdateDevPlanItemTitleRequest                 = 'UpdateDevPlanItemTitleRequest',
  UpdateDevPlanItemTitleResponse                = 'UpdateDevPlanItemTitleResponse',
  UpdateDevPlanItemTitleError                   = 'UpdateDevPlanItemTitleError',

  UpdateDevPlanActionCompleteByDateRequest      = 'UpdateDevPlanActionCompleteByDateRequest',
  UpdateDevPlanActionCompleteByDateResponse     = 'UpdateDevPlanActionCompleteByDateResponse',
  UpdateDevPlanActionCompleteByDateError        = 'UpdateDevPlanActionCompleteByDateError',

  UpdateDevPlanActionStatusRequest              = 'UpdateDevPlanActionStatusRequest',
  UpdateDevPlanActionStatusResponse             = 'UpdateDevPlanActionStatusResponse',
  UpdateDevPlanActionStatusError                = 'UpdateDevPlanActionStatusError',

  UpdateDevPlanFieldAnswerRequest               = 'UpdateDevPlanFieldAnswerRequest',
  UpdateDevPlanFieldAnswerResponse              = 'UpdateDevPlanFieldAnswerResponse',
  UpdateDevPlanFieldAnswerError                 = 'UpdateDevPlanFieldAnswerError',

  GetStatusKeysRequest                          = 'GetStatusKeysRequest',
  GetStatusKeysResponse                         = 'GetStatusKeysResponse',
  GetStatusKeysError                            = 'GetStatusKeysError',

  SetRemindersOnRequest                         = 'SetRemindersOnRequest',
  SetRemindersOnResponse                        = 'SetRemindersOnResponse',
  SetRemindersOnError                           = 'SetRemindersOnError',

  GetRemindersOnRequest                         = 'GetRemindersOnRequest',
  GetRemindersOnResponse                        = 'GetRemindersOnResponse',
  GetRemindersOnError                           = 'GetRemindersOnError',

  SendDevPlanRequest                            = 'SendDevPlanRequest',
  SendDevPlanResponse                           = 'SendDevPlanResponse',
  SendDevPlanError                              = 'SendDevPlanError',

  ClearLastSentEmail                            = 'ClearLastSentEmail',

  SetDevPlanViewedAction                        = 'SetDevPlanViewedAction',

  // Dev Plan Field Answer Lists
  // -------------------------------------------------------------------------------------------------------------------
  GetDevActionListItemsRequest                  = 'GetDevActionListItemsRequest',
  GetDevActionListItemsResponse                 = 'GetDevActionListItemsResponse',
  GetDevActionListItemsError                    = 'GetDevActionListItemsError',

  UpdateFieldAnswerListRequest                  = 'UpdateFieldAnswerListRequest',
  UpdateFieldAnswerListResponse                 = 'UpdateFieldAnswerListResponse',
  UpdateFieldAnswerListError                    = 'UpdateFieldAnswerListError',

  SaveFieldAnswerList                           = 'SaveFieldAnswerList',

  // Dev Plan Collaboration
  // -------------------------------------------------------------------------------------------------------------------
  AuthenticateCollaboratorRequest               = 'AuthenticateCollaboratorRequest',
  AuthenticateCollaboratorResponse              = 'AuthenticateCollaboratorResponse',
  AuthenticateCollaboratorError                 = 'AuthenticateCollaboratorError',

  GetDevPlanCollaboratorsRequest                = 'GetDevPlanCollaboratorsRequest',
  GetDevPlanCollaboratorsResponse               = 'GetDevPlanCollaboratorsResponse',
  GetDevPlanCollaboratorsError                  = 'GetDevPlanCollaboratorsError',

  AddDevPlanCollaboratorRequest                 = 'AddDevPlanCollaboratorRequest',
  AddDevPlanCollaboratorResponse                = 'AddDevPlanCollaboratorResponse',
  AddDevPlanCollaboratorError                   = 'AddDevPlanCollaboratorError',

  SendDevPlanCollaboratorInviteRequest          = 'SendDevPlanCollaboratorInviteRequest',
  SendDevPlanCollaboratorInviteResponse         = 'SendDevPlanCollaboratorInviteResponse',
  SendDevPlanCollaboratorInviteError            = 'SendDevPlanCollaboratorInviteError',

  SetDevPlanCollaboratorAcceptedRequest         = 'SetDevPlanCollaboratorAcceptedRequest',
  SetDevPlanCollaboratorAcceptedResponse        = 'SetDevPlanCollaboratorAcceptedResponse',
  SetDevPlanCollaboratorAcceptedError           = 'SetDevPlanCollaboratorAcceptedError',

  DeleteDevPlanCollaboratorRequest              = 'DeleteDevPlanCollaboratorRequest',
  DeleteDevPlanCollaboratorResponse             = 'DeleteDevPlanCollaboratorResponse',
  DeleteDevPlanCollaboratorError                = 'DeleteDevPlanCollaboratorError',

  GetDevItemCommentsRequest                     = 'GetDevItemCommentsRequest',
  GetDevItemCommentsResponse                    = 'GetDevItemCommentsResponse',
  GetDevItemCommentsError                       = 'GetDevItemCommentsError',

  AddDevItemCommentRequest                      = 'AddDevItemCommentRequest',
  AddDevItemCommentResponse                     = 'AddDevItemCommentResponse',
  AddDevItemCommentError                        = 'AddDevItemCommentError',

  SendDevItemCommentNotificationRequest         = 'SendDevItemCommentNotificationRequest',
  SendDevItemCommentNotificationResponse        = 'SendDevItemCommentNotificationResponse',
  SendDevItemCommentNotificationError           = 'SendDevItemCommentNotificationError',

  SendParticipantCommentNotificationRequest     = 'SendParticipantCommentNotificationRequest',
  SendParticipantCommentNotificationResponse    = 'SendParticipantCommentNotificationResponse',
  SendParticipantCommentNotificationError       = 'SendParticipantCommentNotificationError',

  UpdateDevItemCommentRequest                   = 'UpdateDevItemCommentRequest',
  UpdateDevItemCommentResponse                  = 'UpdateDevItemCommentResponse',
  UpdateDevItemCommentError                     = 'UpdateDevItemCommentError',

  SetDevItemCommentsReadRequest                 = 'SetDevItemCommentsReadRequest',
  SetDevItemCommentsReadResponse                = 'SetDevItemCommentsReadResponse',
  SetDevItemCommentsReadError                   = 'SetDevItemCommentsReadError',

  DeleteDevItemCommentRequest                   = 'DeleteDevItemCommentRequest',
  DeleteDevItemCommentResponse                  = 'DeleteDevItemCommentResponse',
  DeleteDevItemCommentError                     = 'DeleteDevItemCommentError',

  // SetGoals
  // -------------------------------------------------------------------------------------------------------------------
  GoalsAnswersRequest                           = 'GoalsAnswersRequest',
  GoalsAnswersResponse                          = 'GoalsAnswersResponse',
  GoalsAnswersError                             = 'GoalsAnswersError',

  SetGoalAnswerRequest                          = 'SetGoalAnswerRequest',
  SetGoalAnswerResponse                         = 'SetGoalAnswerResponse',
  SetGoalAnswerError                            = 'SetGoalAnswerError',

  SendGoalsRequest                              = 'SendGoalsRequest',
  SendGoalsResponse                             = 'SendGoalsResponse',
  SendGoalsError                                = 'SendGoalsError',


  // ViewReport
  // -------------------------------------------------------------------------------------------------------------------
  LoadReportsRequest                            = 'LoadReportsRequest',
  LoadReportsResponse                           = 'LoadReportsResponse',
  LoadReportsError                              = 'LoadReportsError',

  ReportDataRequest                             = 'ReportDataRequest',
  ReportDataResponse                            = 'ReportDataResponse',
  ReportDataError                               = 'ReportDataError',

  GetEQScoresRequest                            = 'GetEQScoresRequest',
  GetEQScoresResponse                           = 'GetEQScoresResponse',
  GetEQScoresError                              = 'GetEQScoresError',

  SendEQScoresRequest                           = 'SendDevItemCommentNotificationRequest',
  SendEQScoresResponse                          = 'SendEQScoresResponse',
  SendEQScoresError                             = 'SendEQScoresError',

  EQScoresEmailPreviewRequest                   = 'EQScoresEmailPreviewRequest',
  EQScoresEmailPreviewResponse                  = 'EQScoresEmailPreviewResponse',
  EQScoresEmailPreviewError                     = 'EQScoresEmailPreviewError',

  // Report Recipient
  // -------------------------------------------------------------------------------------------------------------------
  ReportRecipientProjectsRequest                = 'ReportRecipientProjectsRequest',
  ReportRecipientProjectsResponse               = 'ReportRecipientProjectsResponse',
  ReportRecipientProjectsError                  = 'ReportRecipientProjectsError',

  ReportRecipientParticipantsRequest            = 'ReportRecipientParticipantsRequest',
  ReportRecipientParticipantsResponse           = 'ReportRecipientParticipantsResponse',
  ReportRecipientParticipantsError              = 'ReportRecipientParticipantsError',

  ReportRecipientReportsRequest                 = 'ReportRecipientReportsRequest',
  ReportRecipientReportsResponse                = 'ReportRecipientReportsResponse',
  ReportRecipientReportsError                   = 'ReportRecipientReportsError',

  DeliverReportsRequest                         = 'DeliverReportsRequest',
  DeliverReportsResponse                        = 'DeliverReportsResponse',
  DeliverReportsError                           = 'DeliverReportsError',

  DeliverReportsToRecipientRequest              = 'DeliverReportsToRecipientRequest',
  DeliverReportsToRecipientResponse             = 'DeliverReportsToRecipientResponse',
  DeliverReportsToRecipientError                = 'DeliverReportsToRecipientError',

  SetLastOnly                                   = 'SetLastOnly',
  SetDateRange                                  = 'SetDateRange',
  AddFilterParticipant                          = 'AddFilterParticipant',
  AddFilterProject                              = 'AddFilterProject',
  RemoveFilterParticipant                       = 'RemoveFilterParticipant',
  RemoveFilterProject                           = 'RemoveFilterProject',

  SetSelected                                   = 'SetSelected',
  SetAllSelected                                = 'SetAllSelected',

  GetDashboardClientsRequest                    = 'GetDashboardClientsRequest',
  GetDashboardClientsResponse                   = 'GetDashboardClientsResponse',
  GetDashboardClientsError                      = 'GetDashboardClientsError',

  GetDashboardAssessmentsRequest                = 'GetDashboardAssessmentsRequest',
  GetDashboardAssessmentsResponse               = 'GetDashboardAssessmentsResponse',
  GetDashboardAssessmentsError                  = 'GetDashboardAssessmentsError',

  GetDashboardDatesRequest                      = 'GetDashboardDatesRequest',
  GetDashboardDatesResponse                     = 'GetDashboardDatesResponse',
  GetDashboardDatesError                        = 'GetDashboardDatesError',

  GetDashboardDefaultsRequest                   = 'GetDashboardDefaultsRequest',
  GetDashboardDefaultsResponse                  = 'GetDashboardDefaultsResponse',
  GetDashboardDefaultsError                     = 'GetDashboardDefaultsError',


  // Trace Logging
  // -------------------------------------------------------------------------------------------------------------------
  LogInfoRequest                                = 'LogInfoRequest',
  LogInfoResponse                               = 'LogInfoResponse',
  LogInfoError                                  = 'LogInfoError',
}

